import { SUGGESTED_ANSWER_VARY } from 'global/constants';
import {
  useGetImageAnswer,
  useGetRichtextAnswer,
} from '../suggested-answers/suggested-answer.hooks';
import { isRichtextEmpty } from 'approot/shared/richtext/richtext.utils';
import type { SuggestedAnswerFragment } from '../suggested-answers/suggested-answers.graphql.generated';

type Props = {
  id: string;
  suggestedAnswerProperties: SuggestedAnswerFragment | null;
};

const useDrawHasSuggestedAnswer = ({
  id,
  suggestedAnswerProperties,
}: Props) => {
  const richtextAnswer = useGetRichtextAnswer({
    componentId: id,
    suggestedAnswerProperties,
  });

  const imageAnswer = useGetImageAnswer({
    componentId: id,
    suggestedAnswerProperties,
  });

  return !!(
    suggestedAnswerProperties?.suggestedAnswerType === SUGGESTED_ANSWER_VARY ||
    imageAnswer ||
    !isRichtextEmpty(richtextAnswer)
  );
};

export default useDrawHasSuggestedAnswer;
